import { Typography } from '@mui/material';
import { convertsCentsToCurrency } from '@npi/buddy-utils';
import { InvoiceItem } from 'types/graphql';

import { Card, LineItemTable } from 'src/components';

interface InvoiceItemsProps {
    lineItems: InvoiceItem[];
}

const InvoiceItems = ({ lineItems }: InvoiceItemsProps) => {
    return (
        <Card gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Invoice Items
            </Typography>
            <LineItemTable
                columnHeaders={[
                    'Ledger Account',
                    'Description',
                    'Quantity',
                    'Net Amount',
                    'Total Line Vat',
                    'Line Total',
                ]}
                data={lineItems?.map(
                    ({ description, ledgerAccount, lineTotal, netAmount, totalVat, quantity }) => {
                        return {
                            quantity,
                            description,
                            ledgerAccount,
                            lineTotal: convertsCentsToCurrency(lineTotal),
                            netAmount: convertsCentsToCurrency(netAmount),
                            totalLineVat: convertsCentsToCurrency(totalVat),
                        };
                    }
                )}
            />
        </Card>
    );
};
export default InvoiceItems;
